import React from 'react';
import PropTypes from 'prop-types';

import {Box, Paper, Typography} from 'views/components';
import {Translate} from 'views/module';

import CohortGraphData from './CohortGraphData';

const CohortSection = (props) => {
  const {
    chartHeight = 340,
    graphSections = [],
    currentDate,
    previousDates,
  } = props;

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '11px',
          fontWeight: 600,
          lineHeight: '14px',
          letterSpacing: '0.04em',
          color: '#A8A49E',
          mb: 2,
        }}
      >
        <Translate expression='metrics.LeadFunnel.CohortSection' />
      </Typography>
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
        {
          graphSections.map((graphSection) => (
            <Paper
              key={graphSection.titleExpression}
              sx={{
                p: 3,
                borderRadius: '12px',
                border: '1px solid #E5E5E5',
                boxShadow: 'none',
              }}
            >
              <CohortGraphData
                chartHeight={chartHeight}
                titleExpression={graphSection.titleExpression}
                stageKeys={graphSection.stageKeys}
                isLoading={graphSection.isLoading}
                errorMessage={graphSection.errorMessage}
                metricsByDate={graphSection.metricsByDate}
                currentDate={currentDate}
                previousDates={previousDates}
              />
            </Paper>
          ))
        }
      </Box>
    </Box>
  );
};

CohortSection.propTypes = {
  chartHeight: PropTypes.number,
  graphSections: PropTypes.array,
  currentDate: PropTypes.string.isRequired,
  previousDates: PropTypes.array.isRequired,
};

export default React.memo(CohortSection);
